<template>
  <div id="appHome">
    <div class="splash"></div>

    <van-dialog
      v-model="showPrivacy"
      :title="$t.privacy.title"
      @confirm="agree"
      :confirm-button-text="$t.meta.agree"
      @cancel="exitApp"
      :cancel-button-text="$t.meta.disagree"
      show-confirm-button
      :show-cancel-button="isApp ? true : false"
      theme="round-button"
      confirm-button-color="#1989fa"
      cancel-button-color="#ee0a24"
    >
      <slot name="default">
        <div class="privacy-alert">
          <div class="text1">{{ $t.privacy.text1 }}</div>
          <div class="text2">
            {{ $t.privacy.text2 }}
            <b @click="gotoPrivacy">
              <u>{{ $t.privacy.text3 }}</u>
            </b>
          </div>
          <div class="end">
            {{ $t.privacy.end }}
          </div>
        </div>
      </slot>
    </van-dialog>
  </div>
</template>
<script>
import { isAPP } from "@/plugins/environment/type.js";

export default {
  name: "AppHome",
  data() {
    return {
      showPrivacy: false,
      isApp: isAPP(), // 当前环境
      isLogin: false,
    };
  },
  beforeMount() {
    let auth = JSON.parse(localStorage.getItem("auth")); //判断是否登录
    if (auth) {
      if (auth.token) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    }

    let isPrivacy = JSON.parse(localStorage.getItem("isPrivacy")); //隐私政策
    if (!isPrivacy) {
      this.showPrivacy = true;
    } else {
      this.next();
      this.initPlugins();
    }
  },
  methods: {
    initPlugins() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.initJpush);
    },
    next() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: this.isLogin ? "home" : "auth/login",
        name: "",
        query: [],
      });
    },
    agree() {
      localStorage.setItem("isPrivacy", true);
      this.next();
      this.initPlugins();
    },
    exitApp() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.exitapp);
    },
    gotoPrivacy() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "privacy",
        name: "privacy",
        query: [],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.privacy-alert {
  padding: 5%;
  font-size: 14px;
  line-height: 2;
}
.splash {
  min-height: 120vh;
  flex-direction: column;
  background-repeat: no-repeat;
  background-size: contain;
  background: -webkit-gradient(
    linear,
    left top,
    right bottom,
    color-stop(0%, #009ed4),
    color-stop(100%, #5029c3)
  );
}
</style>